"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUsAppEnvironment = exports.isProductionEnvironment = exports.resolveAppEnvironment = void 0;
var DEPLOYED_ENVIRONMENTS = [
    'dev',
    'stage',
    'prod',
    'prod-eu',
];
var resolveAppEnvironment = function (nodeEnvironment, configuredEnvironment) {
    if (nodeEnvironment !== 'production') {
        return 'local';
    }
    if (typeof configuredEnvironment === 'string' &&
        DEPLOYED_ENVIRONMENTS.includes(configuredEnvironment)) {
        return configuredEnvironment;
    }
    return 'prod';
};
exports.resolveAppEnvironment = resolveAppEnvironment;
var isProductionEnvironment = function (nodeEnvironment, configuredEnvironment) {
    var environment = (0, exports.resolveAppEnvironment)(nodeEnvironment, configuredEnvironment);
    return environment === 'prod' || environment === 'prod-eu';
};
exports.isProductionEnvironment = isProductionEnvironment;
var isUsAppEnvironment = function (_nodeEnvironment, configuredEnvironment) {
    return configuredEnvironment !== 'prod-eu';
};
exports.isUsAppEnvironment = isUsAppEnvironment;
